import { useState, useContext, useEffect, useMemo } from "react";
import Screen from '../components/Screen';
import { getCDNImage, serviceTypeIcon } from '../globals';
import { i18nValue, getLocale } from '../functions';
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { CheckInContext } from "../context/checkin";
import { useWebPush } from "../context/webpush";
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Reservation from "../components/Reservation";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAngleRight, faComment, faCommentAlt, faQuestion, faHome, faCog, faWifi, faUnlock, faInfo, faMapMarked, faParking, faRecycle, faBed, faStar } from "@fortawesome/free-solid-svg-icons";
import { format, parseISO } from 'date-fns';
import { T } from "react-translator-component";
import LanguageSelector from "../components/LangSelector";
import ButtonPanel from "./Status/ButtonPanel";
import CheckinMessagesCard from "./Status/CheckinMessagesCard";
import { usePersistentState } from "../hooks/usePersistentState";
import useUpsell from "../hooks/useUpsells";
import { isCostaGalana, isHostz, isHostzBecozy, isHostzBlackSummit, isHostzSanCarlo, isOffgrid, isHostzBetaHouse, isHostzMyde, isHostzArosa, isHostzCozy, isHostzSwissstay, isHostzSteiners, isSimplex, isHostzSigma, isKalmStay } from "../components/CheckIn/hotelConditions";
import InfoModal from "../components/InfoModal";
import InfoModal1 from "../components/InfoModal1";
import InfoModal2 from "../components/InfoModal2";
import InfoModalTermsAndConditions from "../components/InfoModalTermsAndConditions";
import ButtonModalPlaceholder from "../components/ButtonModalPlaceholder";
import ButtonModalPlaceholderVideo from "../components/ButtonModalPlaceholderVideo";
import AccessInformationNavLinkDashboard from "../components/AccessInformationNavLinkDashboard";
import processHtml from "../components/processHtml";
import WhatsappContactLink from "../components/WhatsappContactLink";
import LinkToSection from "../components/LinkToSection";
import { getPropertyTermsAndConditionsPlaceholderText } from "../components/CheckIn/hotelTermsAndConditionsPlaceholder";


const Status = (props) => {
  const { data: hotel, placeholders, getUrlPath, languages } = useContext(HotelContext);
  const { stayConfirmInit, inStay, initied, Room, RoomCategory, language, agent, requests, requestsLoading } = useContext(UserContext);
  const { passengers, webCheckInDone, refreshStatus, data } = useContext(CheckInContext);
  const { permission, isPWAInstalled } = useWebPush();
  const { getUpsellingShortToList } = useUpsell();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [hasUpsells, setHasUpsells] = usePersistentState(false);
  const navigate = useNavigate();



  const [wifiModalShow, setWifiModalShow] = useState(false);
  const [accessCodeShow, setAccessCodeiModalShow] = useState(false);
  const [accessInstructionsShow, setAccessInstructionsShow] = useState(false);
  const [termsAndConditionsShow, setTermsAndConditionsShow] = useState(false);

  useEffect(() => {
    if (!hasUpsells)
      getUpsellingShortToList()
        .then((upsells) => setHasUpsells(Array.isArray(upsells) && upsells.length > 0))
        .catch((error) => console.error('Error:', error));
  }, []);


  useEffect(() => {
    if (!data?.status) {
      navigate('../home', { replace: true })
    }
    // if (inStay && !initied) {
    //   console.log('25oct - here')
    //   navigate('../checkin/welcome', { replace: true })
    // }
    // if (data?.status === "in_stay" && !initied) {
    //   stayConfirmInit();
    // }
    refreshStatus();
    setLoading(false);
  }, []);

  const getPlaceholderValueFromCheckin = (phKey) => {
    const placeholders = { ...data?.placeholders }
    let ph_value = '--'
    
    if (placeholders) {
      if (placeholders?.[phKey]) {
        const ph_values = placeholders[phKey];
        if (ph_values?.[language]) {
          ph_value = ph_values[language];
        } else {
          if (ph_values?.['en-US']) {
            ph_value = ph_values['en-US'];
          }
        }
      }
    }
    return ph_value
  }

  const wifi = useMemo(() => {
    if (hotel?.extra?.["wifi-network"]) {
      return {
        network: hotel?.extra?.["wifi-network"] || "",
        password: hotel?.extra?.["wifi-password"] || ""
      }
    }
    return null;
  }, [hotel?.extra]);

  const facilitiesSection = useMemo(() => {
    console.log('HOTEL sect', hotel)
    return hotel?.settings?.sections.find(item => item.code === 'facilities')
  }, [hotel?.settings?.sections]);


  const propertyTermsAndConditionsText = useMemo(
    () => getPropertyTermsAndConditionsPlaceholderText(language, placeholders, data?.placeholders),
    [language, placeholders, data?.placeholders]
  );

  const extraBedPlaceholder = useMemo(() => {
    let _url = getPlaceholderValueFromCheckin("UNIT-EXTRA-BED");
    if (_url) {
      let videoId;
      if (_url.includes('youtube.com') || _url.includes('youtu.be')) {

        const urlParams = new URLSearchParams(new URL(_url).search);
        videoId = urlParams.get('v') || _url.split('v=')[1]?.split('&')[0] || _url.split('youtu.be/')[1]?.split('?')[0];
        return `https://www.youtube.com/embed/${videoId}?autoplay=1`;

      } else if (_url.includes('vimeo.com')) {
        videoId = _url.split('vimeo.com/')[1];
        return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
      }
    }

    return false;
  }, [language]);

  if (loading) {
    return (<div className="text-center mt-4 mb-4" style={{ opacity: 0.3 }}>
      <div className="spinner-border" role="status"></div>
    </div>)
  }


  const parkingInfo = getPlaceholderValueFromCheckin("UNIT-PARKING-INSTRUCTIONS")
  const wifiPlaceholder = getPlaceholderValueFromCheckin("UNIT-WIFI-INSTRUCTIONS")
  const garbage = getPlaceholderValueFromCheckin("UNIT-GARBAGE-DISPOSAL-INSTRUCTIONS")

  console.log('15may - garbage', garbage)
  console.log('15may - parkingInfo', parkingInfo)

  return (
    <Screen
      section={"status"}
      headerTranslucid={true}
      title={"Status"}
    >
      <div>

        <InfoModal
          show={wifiModalShow}
          network={wifi?.network}
          pass={wifi?.password}
          hotelCode={hotel.code}
          setShow={setWifiModalShow}
        />
        <InfoModal1
          hotelId={hotel.id}
          hotelCode={hotel.code}
          checkIn={data}
          roomCode={Room?.code}
          language={language}
          placeholders={placeholders}
          show={accessCodeShow}
          setShow={setAccessCodeiModalShow}
        />
        <InfoModal2
          hotelId={hotel.id}
          hotelCode={hotel.code}
          checkIn={data}
          roomCode={Room?.code}
          language={language}
          placeholders={placeholders}
          show={accessInstructionsShow}
          setShow={setAccessInstructionsShow}
        />
        <InfoModalTermsAndConditions
          hotelId={hotel.id}
          hotelCode={hotel.code}
          language={language}
          show={termsAndConditionsShow}
          setShow={setTermsAndConditionsShow}
        />

        <div
          style={{
            position: "absolute",
            width: "100%",
            marginLeft: -15,
            marginRight: -15,
            height: 310,
            background: hotel?.settings?.homeSliderImages?.[0]
              ? `linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, rgba(0, 0, 0, 1) 95%), url(${getCDNImage(hotel.settings.homeSliderImages[0])})`
              : "linear-gradient(0deg, rgba(152,132,96,1) 35%, rgba(153,153,153,1) 90%)",
            backgroundPosition: "bottom",
            backgroundSize: "cover",
            filter: "contrast(1.2)"
          }}
        >
        </div>
        <div className="mb-4 text-center" style={{ position: "absolute", marginLeft: -15, marginRight: -15, width: "100%" }}>
          <div className="mt-4">
            <LanguageSelector />
          </div>
          <div className="passenger-info">
            <div
              className="passenger-image-container"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >

              <div
                className="mb-2 mt-2 passenger-img-status"
                style={{
                  width: 140,
                  height: 140,
                  borderRadius: "50%",
                  border: "3px solid #FFF",
                  background: "#FFFFFF",
                  position: "relative",
                  overflow: "hidden",
                  zIndex: 1,
                }}
              >
                {passengers[0]?.photos?.selfie ? (
                  <img
                    src={getCDNImage(passengers[0].photos.selfie)}
                    style={{
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                ) : (
                  <img
                    src={getCDNImage(hotel.logo)}
                    className="hotel-logo-status"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      display: "block",
                      backgroundPosition: "center",
                    }}
                  />
                )}
              </div>
            </div>
            <span
              className="d-block text-white"
              style={{
                fontSize: 20,
                textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black"
              }}
            >
              <b>{passengers[0].name + " " + passengers[0].surname}</b>
            </span>
          </div>
        </div>
        <div className="info-status-separator" style={{ height: 260 }} ></div>
      </div>

      {data?.inStay && <ButtonPanel
        hotel={hotel}
        checkInId={data?.id}
        pathname={pathname}
        hasUpsells={hasUpsells}
      />}

      <Reservation
        showStatus={true}
        showPrice={false}
        showMainGuest={false}
        showRowInfo={!isHostzSwissstay(hotel.id)}
        className="mx-2 mb-1 reservation-card-status"
        style={{ boxShadow: "1px 4px 15px rgba(0,0,0,0.20)" }}
      />

      {!data?.inStay && (
        <>
          {(!isOffgrid(hotel.id) && !isHostz(hotel.id) && !isSimplex(hotel.id)) && (
            <CheckinMessagesCard hotelCode={hotel.code} pathname={pathname} data={data} />
          )}
        </>
      )}

      {/* Si la reserva está cancelada, no se muestra la información de acceso*/}
      {isHostz(hotel.id) && data?.status !== "canceled" && (
        <div className="d-block px-2 m-2"
          style={{ boxShadow: "1px 4px 15px rgba(0,0,0,0.20)", background: "#FFF", borderRadius: 8, padding: 10, color: "#444" }}>
          <AccessInformationNavLinkDashboard containerStyle={{ background: "#FFF" }} />
        </div>
      )}
      {/* KalmStay: solo con el web check-in aceptado o en estadía */}
      {isKalmStay(hotel.id) && (data?.status === "accepted" || data?.status === "in_stay") && (
        <div className="d-block px-2 m-2"
          style={{ boxShadow: "1px 4px 15px rgba(0,0,0,0.20)", background: "#FFF", borderRadius: 8, padding: 10, color: "#444" }}>
          <AccessInformationNavLinkDashboard containerStyle={{ background: "#FFF" }} />
        </div>
      )}
      {
        <div className="mx-2 mt-3">
          {requestsLoading && !requests && <div className="text-center mt-4 mb-4" style={{ opacity: 0.3 }}>
            <div className="spinner-border" role="status"></div>
          </div>}
          {requests?.map(row => {

            let _photo = row.data?.photo || row.data?.service?.photo;

            return (
              <NavLink
                key={`${row.type}-${row.id}`}
                className="d-block px-2 mb-3"
                style={{ boxShadow: "1px 4px 15px rgba(0,0,0,0.20)", background: "#FFF", borderRadius: 8, padding: 10, color: "#444", height: 100 }}
                to={row.type === "general" || row.type === "services_booking" || row.showNotification === 50 ? `/${hotel.code}/requests/${row.id}/messages` : `/${hotel.code}/requests/${row.id}`}
                state={{ from: pathname }}
                onClick={(e) => data?.status === 'to_validate' && (e.preventDefault(), e.stopPropagation())}
              >
                <div className="d-flex mt-1">
                  {_photo ? (<div style={{ position: "relative", height: 83 }}>
                    <img
                      className="mb-0 mr-2"
                      src={getCDNImage(_photo)}
                      style={{ width: 70, height: 70, borderRadius: 8, objectFit: "cover" }}
                      alt="Row image"
                    />
                    <div style={{ position: "absolute", bottom: 5, right: 15, background: "white", padding: 5, borderRadius: 6, height: 25, width: 25, border: "1px solid #CCC" }}>
                      <div style={{ marginTop: -8 }}>{serviceTypeIcon(row?.type, 14)}</div>
                    </div>
                  </div>
                  ) : (
                    <div className="mr-2"
                      style={{
                        width: 70,
                        height: 70,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        background: '#FFF',
                        borderRadius: 8,
                        border: '1px solid #EEE',
                        flexShrink: 0, // Evita que el icono se reduzca
                      }}>
                      {serviceTypeIcon(row?.type, 50)}</div>
                  )}

                  <div className="d-flex flex-column flex-grow-1">
                    <div className="d-flex" style={{ justifyContent: "space-between", alignItems: "center" }}>
                      {row.createdAt && <span className="font-size-sm" style={{ flexGrow: 1 }}>
                        {format(parseISO(row.createdAt), " dd MMM HH:mm", { locale: getLocale(language) })}{language === "es-ES" ? " hs" : " hr"}
                      </span>}
                      {row.status && row.showNotification !== 50 && (
                        <span className={`label label-sm label-light-${row.status} label-inline text-uppercase`}>{T(`services.status.${row.status}`)}</span>
                      )}
                       {row?.deliveryPoint && <span className={`label label-sm label-light label-inline text-uppercase ml-2`} style={{ background: '#FFF0A8', color: '#796400'}}>{row?.deliveryPoint}</span>}
                      {row.showNotification === 50 && (
                        <span style={{ background: "#ffe8e8", color: "red" }} className="d-inline-block label label-sm label-light-done label-inline text-uppercase">
                          <FontAwesomeIcon icon={faCommentAlt} style={{ marginRight: 3 }} />{T("status.messages")}
                          <FontAwesomeIcon style={{ marginLeft: 5 }} icon={agent.os === "iOS" ? faAngleRight : faArrowRight} />
                        </span>
                      )}
                    </div>
                    {row.data?.title ? (
                      <>
                        <p
                          className="mt-2"
                          style={{
                            fontSize: 14,
                            fontWeight: "bold",
                            lineHeight: 1.2,
                            height: 35,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            color: "#777777",
                          }}
                        >
                          {i18nValue(row.data, 'title', language) || row.data?.title}
                        </p>
                        {row.data?.bookable && <div className="d-flex justify-content-end" style={{ position: "relative", bottom: "50px", right: "7px" }}>

                          <div className="font-size-sm text-success">
                            <div className="font-size-sm text-success text-right mb-0" style={{ whiteSpace: "nowrap" }}>
                              {T('cups.booked')}
                            </div>
                            {row.data?.bookable?.day && row.data?.bookable?.hour && `${format(parseISO(row.data.bookable.day), "dd MMM yyyy", { locale: getLocale(language) })} - ${row.data.bookable.hour} hs - ${row.data?.bookable?.qty} ${T("cups.spots")}`}
                          </div>
                        </div>}

                      </>
                    ) : (
                      row.type === "services_booking" ? (
                        <>
                          <div className="d-flex justify-content-between mr-1">
                            <p
                              className="mt-2"
                              style={{
                                fontSize: 14,
                                lineHeight: 1.2,
                                fontWeight: "bold",
                                color: "#777777",
                                margin: 0,
                              }}
                            >
                              {i18nValue(row.data?.service, 'name', language)}
                            </p>
                            <span className="font-size-sm text-success mt-2" style={{ whiteSpace: "nowrap" }}>
                              {T('cups.booked')}
                            </span>
                          </div>
                          <div className="d-flex justify-content-end mr-1">
                            <span className="font-size-sm text-success">
                              {row.data?.day && row.data?.hour && `${format(parseISO(row.data.day), "dd MMM yyyy", { locale: getLocale(language) })} - ${row.data.hour} hs - ${row.data?.qty} ${T("cups.spots")}`}
                            </span>
                          </div>
                        </>
                      ) : (
                        <>

                          <p
                            className="mt-2"
                            style={{
                              fontSize: 14,
                              fontWeight: "bold",
                              lineHeight: 1.2,
                              height: 35,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              color: "#777777",
                            }}
                          >
                            {T(`services.type.${row.type}`)}
                            {row.observations && (
                              <>
                                <br />
                                <span
                                  style={{
                                    width: "100%",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    color: "#999999",
                                    fontSize: 12,
                                  }}
                                >
                                  {row.observations}
                                </span>
                              </>
                            )}
                            {(row.type === "room_service" ||
                              row.type === "pool_service" ||
                              row.type === "laundry" ||
                              row.type === "room_supplies" ||
                              row.type === "pressing") && (
                                <>
                                  <br />
                                  <span
                                    style={{
                                      width: "100%",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      color: "#999999",
                                      fontSize: 12,
                                    }}
                                  >
                                    {T("general.items.qty")}: {row.data?.items ? Object.values(row.data?.items).reduce((acc, qty) => acc + qty, 0) : 0}
                                  </span>

                                </>
                              )}
                          </p>
                        </>
                      )
                    )}
                  </div>
                </div>
              </NavLink>
            );
          })}
        </div>
        // )
      }

      <div className="d-block px-2 m-2"
        style={{ boxShadow: "1px 4px 15px rgba(0,0,0,0.20)", background: "#FFF", borderRadius: 8, padding: 10, color: "#444" }}>

        <div className="px-4">
          <h6 className="text-center p-2" style={{ color: "#555555" }}>{T("status.more")}</h6>
        </div>

        {/* Stay */}
        {!isHostz(hotel.id) && data?.inStay && webCheckInDone && <NavLink to={`/${hotel.code}/stay`} state={{ from: pathname }} style={{ textDecoration: "none" }}>
          <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
            <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <FontAwesomeIcon icon={faHome} color="#FFF" style={{ fontSize: 14 }} />
              </div>
              <div className="text-left">
                <p className="mb-0">
                  <b style={{ color: "#555555" }}>{T("status.stay.info")}</b>
                </p>
                <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                  {T("status.stay_description")}
                </p>
              </div>
            </div>
          </div>
        </NavLink>}
        { /* Access Information */}
        {isSimplex(hotel.id) && (
          <AccessInformationNavLinkDashboard containerStyle={{ borderTop: "1px solid #DDD", background: "#FFF" }} />
        )}
        {/* {(wifi && (data?.status === "in_stay" || webCheckInDone) && isHostz(hotel.id)) && <NavLink onClick={() => setWifiModalShow(true)} style={{ textDecoration: "none" }} className="status-wifi">
          <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>

            <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <FontAwesomeIcon icon={faWifi} color="#FFF" style={{ fontSize: 14 }} />
              </div>
              <div className="text-left">
                <p className="mb-0">
                  <b style={{ color: "#555555" }}>{T("status.wifi")}</b>
                </p>
                <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                  {T("status.wifi_description")}
                </p>
              </div>
            </div>
          </div>
        </NavLink>} */}

        { /* WIFI */}
        {(wifi && (!wifiPlaceholder || wifiPlaceholder == '--') && (data?.status === "in_stay" || webCheckInDone) && (isHostz(hotel.id) || isSimplex(hotel.id))) &&
          <ButtonModalPlaceholder
            btnTitle={T("status.wifi")}
            btnDescription={T("status.wifi_description")}
            btnIcon={faWifi}
            modalTitle={T("status.wifi")}
            modalIcon={faWifi}
            placeholderData={
              <p>
                {T("status.wifi_name")}: <b>{wifi?.network}</b>
                <br />
                {T("status.wifi_password")}: <b>{wifi?.password || T("status.wifi_no_password")}</b>
              </p>
            }
            modalClassName={`modal-wifi info-modal-wifi  hotel-${hotel.code}`}
          />
        }
        {(wifiPlaceholder && wifiPlaceholder != '--' && (data?.status === "in_stay" || webCheckInDone) && (isHostz(hotel.id) || isSimplex(hotel.id))) &&
          <ButtonModalPlaceholder
            btnTitle={T("status.wifi")}
            btnDescription={T("status.wifi_description")}
            btnIcon={faWifi}
            modalTitle={T("status.wifi")}
            modalIcon={faWifi}
            placeholderData={
              <p>
                {processHtml(wifiPlaceholder)}
              </p>
            }
            modalClassName={"modal-wifi info-modal-wifi"}
          />
        }
        { /* Access instructions */}
        {data?.status === "in_stay" && (isHostzSanCarlo(hotel.id)) && <NavLink onClick={() => setAccessInstructionsShow(true)} style={{ textDecoration: "none" }} className="status-wifi">
          <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>

            <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <FontAwesomeIcon icon={faUnlock} color="#FFF" style={{ fontSize: 14 }} />
              </div>
              <div className="text-left">
                <p className="mb-0" style={{ lineHeight: 1.25 }}>
                  <b style={{ color: "#555555" }}>{T("status.access_instructions")}</b>
                </p>
                <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                  {T("status.access_instructions_description")}
                </p>
              </div>
            </div>
          </div>
        </NavLink>}

        {/* FAQ Section */}
        {!isHostzSwissstay(hotel.id) && <NavLink to={`/${hotel.code}/faqs`} state={{ from: pathname }} style={{ textDecoration: "none" }}>
          <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
            <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <FontAwesomeIcon icon={faQuestion} color="#FFF" style={{ fontSize: 14 }} />
              </div>
              <div className="text-left">
                <p className="mb-0">
                  <b style={{ color: "#555555" }}>{T("status.faqs")}</b>
                </p>
                <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                  {T("status.faqs_description")}
                </p>
              </div>
            </div>
          </div>
        </NavLink>}
        {/* Parking Section */}
        {isHostzArosa(hotel.id) && <NavLink to={`/${hotel.code}/parking`} state={{ from: pathname }} style={{ textDecoration: "none" }}>
          <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
            <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <FontAwesomeIcon icon={faParking} color="#FFF" style={{ fontSize: 14 }} />
              </div>
              <div className="text-left">
                <p className="mb-0">
                  <b style={{ color: "#555555" }}>{T("status.parking")}</b>
                </p>
                <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                  {T("status.parking_description")}
                </p>
              </div>
            </div>
          </div>
        </NavLink>}
        { /* Location */}
        {!isOffgrid(hotel.id) && hotel.location?.lat && hotel.location?.lng &&
          <NavLink to={`/${hotel.code}/location`} state={{ from: pathname }} style={{ textDecoration: "none" }}>
            <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
              <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <FontAwesomeIcon icon={faMapMarked} color="#FFF" style={{ fontSize: 14 }} />
                </div>
                <div className="text-left">
                  <p className="mb-0">
                    <b style={{ color: "#555555" }}>{T("status.location")}</b>
                  </p>
                  <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                    {!isHostzSwissstay(hotel.id) ? T("status.location_description") : T("status.location_description_swissstay")}
                  </p>
                </div>
              </div>
            </div>
          </NavLink>
        }
        { /* parking */}
        {parkingInfo && parkingInfo != '--' &&
          <ButtonModalPlaceholder
            btnTitle={T("status.parking_info")}
            btnDescription={T("status.parking_info_description")}
            btnIcon={faParking}
            modalTitle={T("status.parking_info")}
            modalIcon={faParking}
            placeholderData={
              <p style={{ textAlign: "justify", marginTop: "1.5rem" }}>
                {processHtml(parkingInfo)}
              </p>
            }
            modalClassName={`modal-parking-info info-modal-parking-info hotel-${hotel.code}`}
          />
        }
        { /* garbage */}
        {garbage && garbage != '--' &&
          <ButtonModalPlaceholder
            btnTitle={T("status.garbage")}
            btnDescription={T("status.garbage_description")}
            btnIcon={faRecycle}
            modalTitle={T("status.garbage")}
            modalIcon={faRecycle}
            placeholderData={
              <p style={{ textAlign: "justify", marginTop: "1.5rem" }}>
                {processHtml(garbage)}
              </p>
            }
            modalClassName={`modal-garbage info-modal-garbage hotel-${hotel.code}`}
          />
        }
        { /* extra-bed */}
        {extraBedPlaceholder &&
          <ButtonModalPlaceholderVideo
            btnTitle={T("status.extra-bed")}
            btnDescription={T("status.extra-bed_description")}
            btnIcon={faBed}
            modalTitle={T("status.extra-bed")}
            modalIcon={faBed}
            placeholderData={extraBedPlaceholder}
            modalClassName={`modal-extra-bed info-modal-extra-bed hotel-${hotel.code}`}
          />
        }

        {/* Contact Us Section */}


        {isHostzBecozy(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/41783126350" />
        )}
        {isHostzSigma(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/41445052256" />
        )}
        {isHostzMyde(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/4915566511786" />
        )}
        {isHostzArosa(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/41798073777" />
        )}
        {isHostzCozy(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/41798076888" />
        )}
        {isHostzSwissstay(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/41798077220" />
        )}
        {isHostzSteiners(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/41755730222" />
        )}
        {isOffgrid(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/493054806375" title={T("status.contact_whatsapp")} />
        )}
        {isSimplex(hotel.id) && (
          <WhatsappContactLink url="https://wa.me/497219098790" />
        )}
        {facilitiesSection && isHostzArosa(hotel.id) && (
          <LinkToSection section={facilitiesSection} icon={faStar} btnDescription={T("status.settings.btnDescription_facilities_arosa")} />
        )}
        {(!isOffgrid(hotel.id) && !isHostz(hotel.id) && !isSimplex(hotel.id)) && (

          <NavLink to={`/${hotel.code}/services/service_general`} state={{ from: pathname }} style={{ textDecoration: "none" }} className="status-contact-us">
            <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
              <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <FontAwesomeIcon icon={faComment} color="#FFF" style={{ fontSize: 14 }} />
                </div>
                <div className="text-left">
                  <p className="mb-0">
                    <b style={{ color: "#555555" }}>{T("status.contact")}</b>
                  </p>
                  <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                    {T("status.contact_description")}
                  </p>
                </div>
              </div>
            </div>
          </NavLink>
        )}

        {data?.status === "in_stay" && (isOffgrid(hotel.id) || isCostaGalana(hotel.id) || isHostzBetaHouse(hotel.id) || isHostzSigma(hotel.id) || propertyTermsAndConditionsText) && <NavLink onClick={() => setTermsAndConditionsShow(true)} style={{ textDecoration: "none" }} className="status-wifi">
          <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>

            <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
              <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                <FontAwesomeIcon icon={faInfo} color="#FFF" style={{ fontSize: 14 }} />
              </div>
              <div className="text-left">
                <p className="mb-0" style={{ lineHeight: 1.25 }}>
                  <b style={{ color: "#555555" }}>{isOffgrid(hotel.id) ? T("checkin.gdpr-button") : T("checkin.terms-and-conditions")}</b>
                </p>
                <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                  {isOffgrid(hotel.id) ? T("checkin.terms-and-conditions") : T("checkin.terms-and-conditions-button-detail")}
                </p>
              </div>
            </div>
          </div>
        </NavLink>}

        {/* Settings */}
        {!isHostz(hotel.id) && !isSimplex(hotel.id) && (
          <>
            {(permission !== "granted" || !isPWAInstalled) && <NavLink to={`/${hotel.code}/settings`} state={{ from: pathname }} style={{ textDecoration: "none" }} className="status-settings">
              <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
                <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                  <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <FontAwesomeIcon icon={faCog} color="#FFF" style={{ fontSize: 14 }} />
                  </div>
                  <div className="text-left">
                    <p className="mb-0">
                      <b style={{ color: "#555555" }}>{T("status.settings")}</b>
                    </p>
                    <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                      {T("status.settings_description")}
                    </p>
                  </div>
                </div>
              </div>
            </NavLink>}
          </>
        )}


      </div>

    </Screen >
  );
}

export default Status;